export default [
	{
		title: 'Personal Details',
		description: "Name, Qualifications",
		status: "",
		
	},
	{
		title: 'Contact Details',
		description: "Email, Mobile.",
		status: "",
	},
	{
		title: 'Specialty',
		description: "Field of study",
		status: "",
	},
	{
		title: 'Special Interests',
		description: "Interest in speciality",
		status: "",
	},
	{
		title: 'Patients Details',
		description: "What kind of patients you see",
		status: "",
	},
	{
		title: 'Billing Policy',
		description: "Consultation Fee",
		status: "",
	},
	{
		title: 'Clinic/Practice',
		description: "Primary/Secondary",
		status: "",
	},
	{
		title: 'Hospital',
		description: "Public/Private",
		status: "",
	},
	{
		title: 'Additional Details',
		description: "",
		status: "",
	},
]


// WEBPACK FOOTER //
// ./src/Containers/store/initSteps.js